module.exports = __webpack_public_path__ + "img/ic_modifier.e64808e5.svg";